import { TASK_FILE_UPLOAD_OPTIONS } from 'NHPTemplates.mod/Form/constants';

interface EmailFilterData {
	selectData: Array<SelectOptions>;
	selectedName: string;
	selectedParentId: string;
	selectedValues: Array<string>;
}

interface EmployeeData {
	email: string;
	firstName: string;
	hireDate: string;
	id: string|number;
	jobTitle: string;
	jobLocation: string;
	managerId: number;
	name: string;
	payrollSynced: boolean;
	photoUrl: string;
	userId?: number;
	employeeSolutions?: string[];
}

interface EsignatureData {
	setup_complete: boolean;
}

// Remove during cleanup
interface File {
	esignature_template_id?: number | string;
	esignatures: EsignatureData;
	ext: string;
	fd_id?: string;
	file_id: string;
	isEsignature?: boolean;
	most_recent_file_data_id: number | string;
	name: string;
	required: 'no' | 'yes';
	scan_info: string;
}

interface UpdatedFile {
	currentSignerUserId: number | string;
	esignatureInstanceId: number | string;
	esignatureRequired: boolean;
	esignatureStatus: EsignatureInstanceStatus | null;
	esignatureTemplateId: number | string;
	esignatureWorkflowId: number | string;
	esignatureWorkflowInstanceId: number | string;
	extension: string;
	fileDataId: string | number;
	fileName: string;
	fileId: number | string;
	isEsignature: boolean;
	isCompletedEsignature: boolean;
	scanInfo: string;
	size: string;
}

type EsignatureInstanceStatus =
	| 'Pending'
	| 'InProgress'
	| 'Canceled'
	| 'Declined'
	| 'Completed'
	| 'Failed';

interface SelectOptions {
	text: string;
	value: number | string;
	name?: string;
	parentId?: string;
	isDisabled?: boolean;
}

interface PacketData {
	employee: {
		email: string;
		hireDate: string;
		id: number;
		jobTitle: string;
		jobLocation: string;
		name: string;
		firstName: string;
		payrollSynced: boolean;
		photoUrl: string;
	}
}

interface PayrollData {
	hasEmployeeTaxInformationEnabled: boolean;
	hasTrax: boolean;
	hasTraxFederalAndDirectDepositEnabled: boolean;
	showFederalWithholding: boolean;
	showPayrollBullets: boolean;
	showStateWithholding: boolean;
}

interface Question {
	archived: string | boolean;
	employeeId?: number | string;
	employeeResponse?: string;
	hidden?: boolean;
	id: number | string;
	is_required: 'yes' | 'no' | '';
	required?: boolean;
	isRequired?: 'yes' | 'no' | '';
	question: string;
	sort_order: number | string;
	sortOrder?: number | string;
}

interface NewHirePacketTask {
	allowEmployeeUploads: TASK_FILE_UPLOAD_OPTIONS;
	applicable: boolean;
	archived: boolean;
	assignedByUserId: number;
	assignedUserId: number;
	canDelete: boolean;
	category: TaskCategory;
	completed: boolean;
	completedDateTime: string;
	completedUserId: number;
	created: string;
	description?: string;
	dueDate: string;
	employeeId: number;
	employeeNewHirePacketId: number;
	employeeTaskListId: number;
	fileIds: Array<number>;
	files: Array<UpdatedFile> | Record<string, UpdatedFile>;
	id: string;
	name: string;
	nhpSortOrder: number;
	originalItemId: number;
	sortOrder: number;
	taskListId: number;
}

interface Task {
	allowEmployeeUploads: TASK_FILE_UPLOAD_OPTIONS;
	applicable: boolean;
	archived: boolean;
	assignedByUserId: number | string;
	assignedUserId: number | string;
	canDelete: boolean;
	categoryId: number | string;
	category: TaskCategory;
	completed: boolean;
	completedDateTime: string;
	completedUserId: number | string;
	created: string;
	description: string;
	dueDate: string;
	employeeId: number | string;
	employeeNewHirePacketId: number | string;
	employeeTasklistItemId: number | string;
	files: Array<File>;
	id: number | string;
	name: string;
	originalItemId: number | string;
	sortOrder: number | string;
	tasklistId: number | string;
}

interface TaskCategory {
	id?: number;
	name: string;
	taskListId?: number;
	sortOrder?: number;
	systemGenerated?: number;
	archived?: boolean
}

interface TasklistData {
	id: number;
	missing: Record<string, string | number>;
	templateTasklistIds: string;
	newHirePacketTasks: Array<Task>;
	viewEdit: boolean;
	canAccessOnboardingSettings: boolean;
}

enum TASKLIST_TYPES {
	DEFAULT = 'default',
	OFFBOARDING = 'offboarding',
	ONBOARDING = 'onboarding',
}

export type TaskList = {
	archived: boolean;
	iconName: string;
	id: number;
	name: string;
	sortOrder: number;
	systemGenerated?: number;
	workFlowName: TASKLIST_TYPES;
};

interface Recipients {
	allEmployees: boolean;
	typeId: number | string;
	type: string;
}

interface User {
	employeeId: number | string;
	name: string;
	userId: number | string;
}

interface TemplateData {
	arriveByTime: string,
	contactOptions: Array<SelectOptions>;
	contactEmployeeId: number;
	id: number | string;
	location: string;
	managerOptions: Array<SelectOptions>;
	name: string;
	otherInstructions: string;
	gtkyQuestions: Record<string, Question>;
	gtkyRecipients: Array<Recipients>;
	requiresPersonalInformation: boolean;
	requiresPhoto: boolean;
	sendGtkyQuestions: boolean;
	sendGetToKnowYouEmail: 'yes'|'no'|''|boolean;
	showPayrollDirectDeposit: 'yes'|'no'|'';
	showPayrollFederal: 'yes'|'no'|'';
	showPayrollState: 'yes'|'no'|'';
	nhpTemplateId: number;
}

interface TemplateOptions {
	id: string;
	name: string;
}

export {
	EmailFilterData,
	EmployeeData,
	EsignatureInstanceStatus,
	File,
	NewHirePacketTask,
	PacketData,
	PayrollData,
	Question,
	Recipients,
	SelectOptions,
	Task,
	TaskCategory,
	TasklistData,
	TemplateData,
	TemplateOptions,
	UpdatedFile,
	User,
};
